import { CommodityTabsKeys, CommodityTabsLabels } from 'enums/FarmPageEnum';
import { ReactComponent as ProductLogo } from 'assets/icons/product.svg';
import { ReactComponent as Review } from 'assets/icons/search.svg';
import { ReactComponent as Verified } from 'assets/icons/verified.svg';
import { ReactComponent as Draft } from 'assets/icons/draft.svg';
import { ReactComponent as Declined } from 'assets/icons/declined.svg';
import { DataMappingProps } from 'enums/CreateProductStageNavigationBarEnums';

export interface GetCommodityTabsProps {
  isActiveTab: (tab: string) => boolean;
}

export interface TabLabelProps {
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  label: string;
  isActive: boolean;
}

export interface TabConfig {
  key: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  label: string;
}

export const TAB_CONFIGS: TabConfig[] = [
  {
    key: CommodityTabsKeys.ALL_COMMODITIES,
    icon: ProductLogo,
    label: CommodityTabsLabels.ALL_COMMODITIES,
  },
  {
    key: CommodityTabsKeys.IN_REVIEW,
    icon: Review,
    label: CommodityTabsLabels.IN_REVIEW,
  },
  {
    key: CommodityTabsKeys.APPROVED,
    icon: Verified,
    label: CommodityTabsLabels.APPROVED,
  },
  {
    key: CommodityTabsKeys.DRAFT,
    icon: Draft,
    label: CommodityTabsLabels.DRAFT,
  },
  {
    key: CommodityTabsKeys.DECLINED,
    icon: Declined,
    label: CommodityTabsLabels.DECLINED,
  },
];

export const inReviewStatus = 'in review';
export const IN_REVIEW_ROUTE = 'in-review';

export const statusMapping: Record<string, string | undefined> = {
  'in-review': 'in-review',
  declined: 'declined',
  approved: 'approved',
  draft: 'draft',
  'all-commodities': undefined,
};

export const stageMapping: Record<number, string> = {
  0: DataMappingProps.RAW_MATERIAL,
  1: DataMappingProps.RAW_MATERIAL,
  2: DataMappingProps.TRANSPORTATION,
  3: DataMappingProps.FUEL_AND_ENERGY,
  4: DataMappingProps.FIELD,
  5: DataMappingProps.COMMODITY_DISTRIBUTION,
  6: DataMappingProps.FARMBOX_OVERVIEW,
};

export const livestockStageMapping: Record<number, string> = {
  0: DataMappingProps.FEED_PATH,
  1: DataMappingProps.FEED_PATH,
  2: DataMappingProps.TRANSPORTATION,
  3: DataMappingProps.FUEL_AND_ENERGY,
  4: DataMappingProps.MANURE_MANAGEMENT_ROUTE,
  5: DataMappingProps.COMMODITY_DISTRIBUTION,
  6: DataMappingProps.FARMBOX_OVERVIEW,
};

export const CommodityStatusParams = {
  PAGE: 'page',
  LIMIT: 'limit',
  PAGE_DEFAULT: '1',
  LIMIT_DEFAULT: '10',
};

export const statusMappingWithStage: Record<string, string | undefined> = {
  'in-review': 'in-review',
  declined: 'declined',
  approved: 'approved',
  draft: 'draft',
};

export const validNotificationEvent = [
  'farm_commodity_approved',
  'farm_commodity_declined',
];

export const socketNotificationLabel = 'notification';
